import { getLocale } from 'i18n';
import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react'
import styles from './DocumentView.module.scss'

const STATUS_COLORS = {
  draft:     { bg: "var(--theme-surface-muted, #f1f5f9)", color: "var(--theme-text-muted, #64748b)" },
  pending:   { bg: "var(--theme-warning-soft, #fef9c3)", color: "var(--theme-orange-text, #854d0e)" },
  signing:   { bg: "var(--theme-info-soft, #dbeafe)", color: "var(--theme-info-text, #1d4ed8)" },
  approved:  { bg: "var(--theme-success-soft, #dcfce7)", color: "var(--theme-success-text, #15803d)" },
  returned:  { bg: "var(--theme-danger-soft, #fee2e2)", color: "var(--theme-danger-text, #b91c1c)" },
  cancelled: { bg: "var(--theme-surface-muted, #f3f4f6)", color: "var(--theme-text-muted, #6b7280)" },
}

function fmtDate(str) {
  if (!str) return '—'
  const d = new Date(str)
  if (isNaN(d.getTime())) return str
  return d.toLocaleDateString(getLocale(), { day: '2-digit', month: 'long', year: 'numeric' })
}

export default function DocHeader({ doc }) {
  useInterfaceLanguage();
  const sc = STATUS_COLORS[doc.status] || STATUS_COLORS.draft

  return (
    <div className={styles.docHeader}>
      {/* Reg block */}
      <div className={styles.headerTop}>
        <div className={styles.regBlock}>
          <span className={styles.regLabel}>{tr("Регистрационный номер")}</span>
          <span className={styles.regNum}>{tr(doc.reg_number)}</span>
        </div>
        <span className={styles.statusBadge} style={{ background: sc.bg, color: sc.color }}>
          {tr(doc.status_display)}
        </span>
      </div>

      {/* Subject */}
      <h2 className={styles.docSubject}>{tr(doc.subject)}</h2>

      {/* Meta grid */}
      <dl className={styles.metaGrid}>
        <dt>{tr("Тип")}</dt>
        <dd>{tr(doc.doc_type_display)}</dd>

        <dt>{tr("Дата")}</dt>
        <dd>{fmtDate(doc.created_at)}</dd>

        <dt>{tr("Отправитель")}</dt>
        <dd>
          <strong>{tr(doc.from_employee_name)}</strong>
          {tr(doc.from_employee_dept && (
            <span className={styles.metaSub}>{tr(doc.from_employee_dept)}</span>
          ))}
        </dd>

        <dt>{tr("Получатель")}</dt>
        <dd>
          <strong>{tr(doc.to_employee_name || '—')}</strong>
          {tr(doc.to_employee_dept && (
            <span className={styles.metaSub}>{tr(doc.to_employee_dept)}</span>
          ))}
        </dd>

        {tr(doc.resolution_name && (
          <>
            <dt>{tr("Резолюция")}</dt>
            <dd>
              <strong>{tr(doc.resolution_name)}</strong>
              {tr(doc.resolution_dept && (
                <span className={styles.metaSub}>{tr(doc.resolution_dept)}</span>
              ))}
            </dd>
          </>
        ))}

        {tr(doc.status === 'returned' && doc.return_reason && (
          <>
            <dt>{tr("Причина возврата")}</dt>
            <dd className={styles.returnReason}>{tr(doc.return_reason)}</dd>
          </>
        ))}
      </dl>
    </div>
  )
}
